import React from "react";
import { Outlet } from "react-router-dom";
import InnerHeader from "../common/InnerHeader/InnerHeader";
import InnerFooter from "../common/InnerFooter/InnerFooter";
import Sidebar from "../common/Sidebar/Sidebar";
import PrivateRoute from "../utils/privateroute";


const InnerPagesLayout = (props) => {

   

     
    return (
     <PrivateRoute>
            <>
           <InnerHeader />
           <div className="InrPgLyOtLdDv">
                <div className="InrPgLyOtDataInr">
                    <Sidebar />
                    <div className="InrPgLyOtDataRgtSd">
                        
                        <div className="InrPgLyOtDataRgtSdLdv">
                            <Outlet />
                        </div>                        
                        <InnerFooter />
                    </div>
                </div>                
           </div>           
        </>
     </PrivateRoute>
    );   
}
export default InnerPagesLayout;